import styled from 'styled-components';

export default styled.div`
  justify-self: center;
  margin-bottom: 0.5rem;
`;
